interface Field<TValue> {
    id?: string;
    name?: string;
    tags?: unknown[];
    desc?: unknown;
    saas_desc?: unknown;
    value: TValue;
    initialValue: TValue;
    validators: object;
    notifications: object;
    error: string | null;
    searchable: boolean;
    isDirty: boolean;
}

interface AccountMatchingFieldValue {
    isAccountMatchingEnabled: boolean;
    shouldOverrideManualMatches?: boolean;
}

interface AdFieldsFieldValue {
    matchAttribute: string;
    primaryUserIdentifyAttribute: string;
    primaryUserIdentifyValue: string;
}

export type UserManagementReducerState = {
    accountMatching: {
        id: string;
        name: string;
        fields: {
            accountMatching: Field<AccountMatchingFieldValue>;
            adFieldsConfig: Field<AdFieldsFieldValue | undefined>;
            isCaseSensitive: Field<boolean | undefined>;
            isTokenSharingEnabled: Field<boolean>;
        };
    };
    enrollmentSettings: {
        id: string;
        name: string;
        fields: {
            UserTokensLimit: Field<number>;
            BlockUnpairedUsers: Field<boolean>;
            SendNewTokenEmail: Field<boolean>;
        };
    };
};

export type AccountMatchingState = UserManagementReducerState['accountMatching']['fields'];

export type AccountMatchingStateValues = {
    [Key in keyof AccountMatchingState]: AccountMatchingState[Key]['value'];
};

export type UpdateAccountMatchingAction = {
    type: UserManagementActionTypes.UPDATE_ACCOUNT_MATCHING_SETTINGS;
    payload: AccountMatchingStateValues;
};

type EnrollmentSettingsStateValues = {
    [Key in keyof UserManagementReducerState['enrollmentSettings']['fields']]?: UserManagementReducerState['enrollmentSettings']['fields'][Key]['value'];
};

export enum UserManagementActionTypes {
    UPDATE_ACCOUNT_MATCHING_SETTINGS = 'update_account_matching_settings',
    UPDATE_ENROLLMENT_SETTINGS = 'update_enrollment_settings'
}

export type UpdateEnrollmentSettingsAction = {
    type: UserManagementActionTypes.UPDATE_ENROLLMENT_SETTINGS;
    payload: EnrollmentSettingsStateValues;
};

export type UserManagementSettingsAction = UpdateAccountMatchingAction | UpdateEnrollmentSettingsAction;
